import { graphql } from "@/gql";

export const supplierTermsAndConditionsRecord = graphql(`
  query SupplierTermsAndConditionsRecord(
    $supplierId: ID!
    $relocationType: RelocationType = RELOCATION
  ) {
    supplierTermsAndConditions(
      supplierId: $supplierId
      relocationType: $relocationType
    ) {
      id
      relocation_type
      pdf_url
      pdf {
        id
        url
        file_name
      }
      license_requirements
    }
  }
`);
